import { Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, TextField } from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import CropFreeIcon from '@material-ui/icons/CropFree'; // Barkod okutma için standart ikon
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { loadUrunControlDetail, saveUrunControlDetail } from 'src/utils/storage/StartWorkOrder';
import BarkodPopup from '../../components/BarcodePopup';
import UrunSearch from '../../components/Selects/ProductSearch';
import { text } from '../../modules/languages/index';
import { getDefectRequest, getLabourRequest, getMaterialRequest, resetDefects, resetLabours, resetMaterials } from '../../store/actions';

const useStyles = makeStyles((theme) => ({
  rootProductControl: {},
  avatarProductControl: {
    backgroundColor: red[500],
  },
  fieldsProductControl: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policyProductControl: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckboxProductControl: {
    marginLeft: '-14px'
  },
  submitButtonProductControl: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  contentProductControl: {
    padding: 0,
  },
}));

function ProductControl({ className }) {
  const [openProductControl, setOpenProductControl] = React.useState(false);
  const [UyariProductControl, setUyariProductControl] = React.useState("");
  const classes = useStyles();
  const [UrunDataProductControl, setUrunDataProductControl] = useState({});
  const [openBarkod, setOpenBarkod] = useState(false);
  const [maxYilProductControl] = useState(new Date().getFullYear());
  const [, setUrunBarkod] = useState("");
  const [, setBarkod] = useState("");
  const [search, setSearch] = useState('');
  // const [formValidProductControl, setFormValidProductControl] = useState(true);
  const [formStateProductControl, setFormStateProductControl] = useState([
    {
      name: 'SERINO',
      min: 0,
      max: 9999999999,
      valid: true,
      errorMessage: 'Maximum 10 hane girilebilir!...'
    },
    {
      name: 'UYIL',
      min: 0,
      max: maxYilProductControl,
      valid: true,
      errorMessage: `Maximum ${maxYilProductControl} girilebilir!...`
    },
    {
      name: 'UDONEM',
      max: 12,
      min: 0,
      valid: true,
      errorMessage: '1 ile 12 arası girilebilir!..'
    }
  ]);

  function getDonemFromHaftaGercek(yil, hafta) {
    var simple = new Date(yil, 0, 1 + (hafta - 1) * 7);
    var dow = simple.getDay();
    var ISOweekStart = simple;
    if (dow <= 4)
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    else
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    var month = (ISOweekStart.getMonth() + 1).toString().padStart(2, "0");
    return month;
  }

  const handleBarkodClose = async (barkod) => {
    //barkod bazen başında veya sonunda boşluk karakteri ile gelebiliyor, bu yüzden trim ile temizliyoruz.
    barkod = barkod.trim();
    setOpenBarkod(false);
    if (barkod.length === undefined) {
      return;
    }
    if (barkod.length !== undefined) {
      setUrunBarkod(barkod);
    }

    if ((barkod.length === 12 || barkod.length === 14) && barkod.substring(0, 1) === 'A' && /^\d+$/.test(barkod.substring(2, 12))) {
      barkod = await barkodManipulate(barkod.substring(0, 12));
    }
    let txt_nitelik = 0;
    var model_length = 0;
    if (barkod.length === 24) {
      model_length = 12;
    } else {
      model_length = barkod.length === 18 ? 6 : 10;
    }
    var txt_kul_model_kodu = barkod.substring(0, model_length);
    var remaining = barkod.substring(model_length, barkod.length);
    var txt_uyıl = '20' + remaining.substring(0, 2);
    var txt_serino = remaining.substring(2, 8);
    var txt_udonem = remaining.substring(8, 10);

    if (txt_kul_model_kodu.slice(-2) === 'RV' || txt_kul_model_kodu.slice(-2) === '99') {
      txt_nitelik = 1;
    }

    if (barkod.length === 24 && model_length === 12 && (txt_kul_model_kodu.startsWith("85999") || txt_kul_model_kodu.startsWith("86999"))) {
      txt_uyıl = '20' + barkod.substring(14, 16);
      var Hafta = barkod.substring(16, 18);
      txt_serino = barkod.substring(18, 24);
      txt_udonem = getDonemFromHaftaGercek(txt_uyıl, parseInt(Hafta));
    }


    setSearch(txt_kul_model_kodu);

    UrunDataProductControl.UYIL = parseInt(txt_uyıl);
    UrunDataProductControl.UDONEM = parseInt(txt_udonem);
    UrunDataProductControl.SERINO = parseInt(txt_serino);
    UrunDataProductControl.NITELIK_KODU = parseInt(txt_nitelik);
    UrunDataProductControl.BARKOD = barkod;

    let job = UrunDataProductControl;
    job = { ...job, "UYIL": parseInt(txt_uyıl) };
    setUrunDataProductControl(job);
    saveUrunControlDetail(job);

    job = { ...job, "UDONEM": parseInt(txt_udonem) };
    setUrunDataProductControl(job);
    saveUrunControlDetail(job);


    job = { ...job, "SERINO": parseInt(txt_serino) };
    setUrunDataProductControl(job);
    saveUrunControlDetail(job);

    job = { ...job, "NITELIK_KODU": parseInt(txt_nitelik) };
    setUrunDataProductControl(job);
    saveUrunControlDetail(job);

  }


  const barkodManipulate = async (maliId) => {
    let result;
    await axios.get(`/GetArtemisBarkodFromMaliId/${maliId}`).then((response) => {
      setBarkod(response.data[0]?.BARKOD);
      result = response.data[0]?.BARKOD;
    }).catch(() => {
      setUyariProductControl("Barkod Çözümleme Sırasında hata ile karşılaşıldı.");
      setOpenProductControl(true);
    });
    return result;
  };



  useEffect(() => {
    let storeDataProductControl = loadUrunControlDetail();
    if (storeDataProductControl.length !== 0) {
      setUrunDataProductControl(storeDataProductControl[0]);
    } else {
      setUrunDataProductControl({});
    }
  }, []);

  const handleChangeProductControl = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    let tmpValid = true;
    for (let i = 0; i < formStateProductControl.length; i++) {
      const obj = formStateProductControl[i];
      if (obj.name === name && value) {
        if (value > obj.max || value <= obj.min) {
          setFormStateProductControl([...formStateProductControl.slice(0, i), { ...obj, valid: false }, ...formStateProductControl.slice(i + 1)])
        } else {
          setFormStateProductControl([...formStateProductControl.slice(0, i), { ...obj, valid: true }, ...formStateProductControl.slice(i + 1)])
        }
      }
      tmpValid = tmpValid && obj.valid;
    }


    let obj = formStateProductControl.filter(f => f.name === name)[0];
    if (parseInt(value) > obj.min && parseInt(value) <= obj.max) {
      let job = UrunDataProductControl;
      job = { ...job, [name]: value };
      setUrunDataProductControl(job);
      saveUrunControlDetail(job);
    } else {
      let job = UrunDataProductControl;
      job = { ...job, [name]: obj.min };
      setUrunDataProductControl(job);
      saveUrunControlDetail(job);
    }


  };

  const setModel = (param) => {
    let job = loadUrunControlDetail()[0];

    if (!param.KUL_MODEL_KODU) {
      return;
    }

    setUyariProductControl("Ürün değiştirdiğiniz için fiş üzerindeki hizmet bilgileri silinecektir!");
    setOpenProductControl(true);
    resetLabours();
    resetDefects();
    resetMaterials();
    getDefectRequest(param.KUL_MODEL_KODU, 1);
    getMaterialRequest(param.KUL_MODEL_KODU, 1, 1, UrunDataProductControl.UYIL || 0, UrunDataProductControl.UDONEM || 0, UrunDataProductControl.SERINO || '0');
    getLabourRequest(param.KUL_MODEL_KODU, 1, 1);
    job = {
      ...job,
      KUL_MODEL_KODU: param.KUL_MODEL_KODU,
      MODEL: param.ACIKLAMA,
      HOMEWHIZ: param.HOMEWHIZ,
      MARKA_KODU: param.MARKA_KODU,
    }
    setUrunDataProductControl(job);
    saveUrunControlDetail(job);
  }

  const handleClose = () => {
    setOpenProductControl(false);
  };


  return (
    <Card
      className={clsx(classes.rootProductControl, className)}
    >
      <CardHeader
        title="Ürün Bilgileri"
        action={
          <IconButton
            aria-label="barcode-scan"
            onClick={() => setOpenBarkod(true)}
          >
            <CropFreeIcon color="primary" />
          </IconButton>
        }
      />
      <Divider />
      <CardContent className={classes.contentProductControl}>
        <Dialog
          open={openProductControl}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description" >
          <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {UyariProductControl}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Tamam
            </Button>
          </DialogActions>
        </Dialog>
        <form
          className={clsx(classes.rootProductControl, className)}
        >
          <div className={classes.fieldsProductControl}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <UrunSearch setModel={setModel} value={{
                  KUL_MODEL_KODU: UrunDataProductControl.KUL_MODEL_KODU,
                  ACIKLAMA: UrunDataProductControl.MODEL
                } || ''}
                  searchParam={search}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label={text("uyıl")}
                  name="UYIL"
                  type="number"
                  autoFocus={false}
                  value={UrunDataProductControl.UYIL || ''}
                  fullWidth
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={handleChangeProductControl}
                  variant="outlined"
                  error={!formStateProductControl.filter(n => n.name === "UYIL")[0]?.valid}
                  helperText={formStateProductControl.filter(n => n.name === "UYIL")[0]?.valid ? '' : formStateProductControl.filter(n => n.name === "UYIL")[0]?.errorMessage}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label={text("udonem")}
                  name="UDONEM"
                  value={UrunDataProductControl.UDONEM || ''}
                  type="number"
                  fullWidth
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={handleChangeProductControl}
                  variant="outlined"
                  error={!formStateProductControl.filter(n => n.name === "UDONEM")[0]?.valid}
                  helperText={formStateProductControl.filter(n => n.name === "UDONEM")[0]?.valid ? '' : formStateProductControl.filter(n => n.name === "UDONEM")[0]?.errorMessage}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label={text("serino")}
                  name="SERINO"
                  type="number"
                  value={UrunDataProductControl.SERINO || ''}
                  fullWidth
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={handleChangeProductControl}
                  variant="outlined"
                  error={!formStateProductControl.filter(n => n.name === "SERINO")[0]?.valid}
                  helperText={formStateProductControl.filter(n => n.name === "SERINO")[0]?.valid ? '' : formStateProductControl.filter(n => n.name === "SERINO")[0]?.errorMessage}
                />
              </Grid>
            </Grid>
          </div>
        </form>
      </CardContent>
      <BarkodPopup
        onClose={handleBarkodClose}
        open={openBarkod}
        ScanTime={0}
        CallScreen={0}
      />
    </Card>
  );
}

ProductControl.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({ tasks: state.tasks1 }),
  { resetLabours, resetDefects, resetMaterials, getDefectRequest, getLabourRequest, getMaterialRequest }
)(ProductControl);
